import moment from 'moment'

import {
    FieldInCard,
} from 'app/types/form.types'
import dateMask from 'app/utils/date/dateMask'

export type CalibrationItem = {
    lastCalibratedOn?: string,
    attachment?: [{
        id: number,
    }],
}

const uploadDocFieldsConfig = (uploadAllowed): FieldInCard<keyof CalibrationItem>[] => {
    return [
        {
            id: 'column1',
            fields: [{
                name: 'lastCalibratedOn',
                required: true,
                labelKey: 'Logger.lastCalibratedOn',
                componentName: 'DateTimeSelect',
                maxDate: moment().format(dateMask),
            }],
        },
        {
            id: 'column2',
            fields: [{
                name: 'attachment',
                required: true,
                componentName: 'AttachmentsObjectSelector',
                labelKey: 'SkyCube.supportingDocuments',
                upload: uploadAllowed,
                multiple: false,
                acceptType: 'application/pdf',
            }],
        },
    ]
}

export default uploadDocFieldsConfig
